import React from 'react';

// Named numeric limits, each with its range. An empty box means the policy does not set that limit (the one beneath it, or the default, decides).
// A limit set to 0 is a value, not a blank: for most of them 0 switches the check off.
export default function LimitsField({ field, value, onChange }) {
  const values = value || {};
  const set = (name, text) => onChange({ ...values, [name]: text });
  return (
    <div className="limits">
      {(field.limits || []).map((l) => (
        <div className="limit-row" key={l.name}>
          <label htmlFor={`limit-${l.name}`}>{l.label}</label>
          <input id={`limit-${l.name}`} type="number" min="0" max={l.max} step="1" placeholder="not set" value={values[l.name] === undefined ? '' : values[l.name]}
            onChange={(e) => set(l.name, e.target.value)} />
          <span className="help">{l.help} <span className="range">0 to {l.max}</span></span>
        </div>
      ))}
      {(field.extra || []).map((x) => (
        <div className="limit-row" key={x.name}>
          <label htmlFor={`limit-${x.name}`}>{x.label}</label>
          <input id={`limit-${x.name}`} type="text" maxLength={x.max} placeholder="optional" value={values[x.name] === undefined ? '' : values[x.name]}
            onChange={(e) => set(x.name, e.target.value)} />
          <span className="help">{x.help}</span>
        </div>
      ))}
    </div>
  );
}
